module.exports = __webpack_public_path__ + "static/img/device.67c1cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/device.png
// module id = EPSy
// module chunks = 1 3